export default __webpack_public_path__ + "static/media/sm1.a8ea5c04.jpeg";